import { inject, Injectable, signal } from '@angular/core';

import { PhoneApiService } from './phone-api.service';
import { CountryPhoneInfo } from './models/country-phone-info';

@Injectable({ providedIn: 'root' })
export class PhoneService {
    readonly phoneApiService = inject(PhoneApiService);

    countryPhoneInfo = signal<CountryPhoneInfo[]>([]);

    public loadCountryPhoneInfo(): void {
        if (this.countryPhoneInfo().length > 0) {
            return;
        }

        this.phoneApiService.loadCountryPhoneInfo().subscribe(countryPhoneInfo => this.countryPhoneInfo.set(countryPhoneInfo));
    }
}
